import ozZapMagazinePostList from './oz-zap-magazine-post-list.vue'

export default ozZapMagazinePostList
